import { usePublicLanguage } from './PublicLanguage';
import React from 'react';
import PublicLayout, { PublicThemeProps } from './PublicLayout';
export interface StaticDocument {
  slug: string;
  title: string;
  html: string;
  description?: string;
  schemaType?: string;
  contentLocale?: string;
}
export default function StaticPage({
  page,
  ...theme
}: PublicThemeProps & { page: StaticDocument }) {
  const { locale, t } = usePublicLanguage();
  return (
    <PublicLayout {...theme}>
      <article className="public-article home-width">
        <h1>{page.title}</h1>
        {locale !== 'en' && ['privacy-policy', 'terms-of-service'].includes(page.slug) && (
          <p className="home-small">
            {t('Convenience translation of the English original.')}{' '}
            <a href={`/en/${page.slug}/`} lang="en">
              {t('English original')}
            </a>
          </p>
        )}
        <div
          lang={page.contentLocale || locale}
          className="article-body"
          dangerouslySetInnerHTML={{ __html: page.html }}
        />
      </article>
    </PublicLayout>
  );
}
